module.exports = __webpack_public_path__ + "img/odonto_emergenza_nucleo.ade4e555.jpg";